module.exports = __webpack_public_path__ + "media/images/responsive/page_common/noimage/landscape/deco_gray02-7cac35267964f12de5b00ffb2bce4190.png";